export default "__VITE_ASSET__DAAKqtjP__"